var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCalendarIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 5C10 4.44772 9.55228 4 9 4C8.44772 4 8 4.44772 8 5C5.79086 5 4 6.79086 4 9V20C4 22.2091 5.79086 24 8 24H20C22.2091 24 24 22.2091 24 20V9C24 6.79086 22.2091 5 20 5C20 4.44772 19.5523 4 19 4C18.4477 4 18 4.44772 18 5H10ZM19 8C18.4477 8 18 7.55228 18 7H10C10 7.55228 9.55228 8 9 8C8.44772 8 8 7.55228 8 7C6.89543 7 6 7.89543 6 9V11H22V9C22 7.89543 21.1046 7 20 7C20 7.55228 19.5523 8 19 8ZM22 13H6V20C6 21.1046 6.89543 22 8 22H20C21.1046 22 22 21.1046 22 20V13Z",
  fill: "currentColor"
})));
export { SvgCalendarIcon as ReactComponent };